import React from 'react';
import { bindActionCreators } from 'redux';
import { withLocalize } from 'react-localize-redux';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { reportActions } from '../../store/reportStore';
import OldStyleTableWithHistory from '../common/oldStyleTableWithHistory';
import GeneralAssemblyItem from './generalAssemblies/generalAssemblyItem';
import ExcelExportButton from '../common/excelExportButton';
import Paging from '../common/pagingComponent';

import './generalAssembliesData.scss';

class GeneralAssembliesData extends React.Component {
    shouldComponentUpdate(nextProps, _) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    get section() {
        return this.props.sections.find(o => o.id === this.props.sectionId);
    }

    get pageSize() {
        const limits = this.props.getSectionLimits(this.props.reportType, this.props.sectionId);
        return this.section.isLimited ? limits.pageSize.limited : limits.pageSize.unlimited;
    }

    render() {
        const { data, isLimited } = this.section;
        return isNullOrUndefined(data) || isNullOrUndefined(data.items) ? null : this.renderContent(data, isLimited);
    }

    renderContent = (data, isLimited) => {
        return (
            <div>
                <OldStyleTableWithHistory stripped tableColumns={2}
                    resolveExpanded={this.props.resolveExpanded}
                    head={() => <thead className="gen-assemblies-header">
                        <tr>
                            <th className="col-1" style={{ textAlign: "right" }}><Translate id="Report.GeneralAssemblies.Date" /></th>
                            <th className="col-2"><Translate id="Report.GeneralAssemblies.Type" /></th>
                            <th ><Translate id="Report.GeneralAssemblies.Place" /></th>
                            <th className="col-4" style={{ textAlign: "right" }}><Translate id="Report.GeneralAssemblies.DeterminationDate" /></th>
                            <th className="col-5"><Translate id="Report.GeneralAssemblies.Media" /></th>
                            <th className="col-6" style={{ textAlign: "right" }}><Translate id="Report.GeneralAssemblies.AnnouncementDate" /></th>
                            <th className="col-7"></th>
                        </tr>
                    </thead>}
                    actualData={data.items}
                    actualRow={(r) => <GeneralAssemblyItem key={r.id} data={r} />}
                />
                {isLimited && data.totalCount > this.pageSize && <div>
                    <a className="link-functional" target="_blank" href={this.props.getUnlimitedSectionLink(this.props.reportType, this.props.id, this.props.sectionId)}>
                        <Translate id="Report.Common.ShowAll" />&nbsp;({data.totalCount})
                    </a>
                </div>}
                {!isLimited && data.totalCount > this.pageSize && <div style={{ marginTop: "2em" }}>
                    <Paging
                        justify="center"
                        selectedPage={this.state.page}
                        totalPages={Math.ceil(data.totalCount / this.pageSize)}
                        setPage={page => this.onChangePage(page)}
                    />
                </div>}
                <ExcelExportButton link="general-assemblies" entityId={this.props.id} report={this.props.reportType} />
            </div>
        )
    }

    onChangePage = (page) => {
        this.props.fetchMoreData(
            [this.props.sectionId],
            { count: this.pageSize, offset: (page - 1) * this.pageSize, report: this.props.reportType },
            null, this.replaceData, () => this.setState({ page: page })
        );
    }

    replaceData = (_hint, _oldData, data) => data;
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(GeneralAssembliesData));